import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Cancel, FavoriteOutlined, Unlock } from '@vgno/icons';

import { Button } from '../Button/Button';
import { login } from '../../services/schibstedAccount';
import { rawTrackEngagementEvent } from '../../services/tracking/pulse';
import { Overlay } from '../Overlay/Overlay';

import { useFavouritesPopup } from './useFavouritesPopup';

import * as styles from './FavouritesPopup.module.scss';

const FavouritesPopup = () => {
  const { t } = useTranslation();
  const { hideFavouritesPopup, favouritesPopupVisible } = useFavouritesPopup();

  const trackFavouritesPopupView = useCallback(() => {
    rawTrackEngagementEvent({
      intent: 'View',
      object: {
        name: 'FavouritesPopup',
        type: 'UIElement',
        id: 'favourites-popup',
        elementType: 'Popup',
      },
    });
  }, []);

  const trackCloseClick = useCallback(() => {
    rawTrackEngagementEvent({
      action: 'Click',
      intent: 'Dismiss',
      object: {
        type: 'UIElement',
        id: 'favourites-popup-close',
      },
    });
  }, []);

  const trackLoginClick = useCallback(() => {
    rawTrackEngagementEvent({
      action: 'Click',
      intent: 'Login',
      object: {
        type: 'UIElement',
        id: 'favourites-popup-login',
      },
    });
  }, []);

  useEffect(() => {
    if (favouritesPopupVisible) {
      trackFavouritesPopupView();
    }
  }, [trackFavouritesPopupView, favouritesPopupVisible]);

  const handleLoginClick = () => {
    login({ source: 'favourites' });
    hideFavouritesPopup();
    trackLoginClick();
  };

  const handleClose = () => {
    hideFavouritesPopup();
    trackCloseClick();
  };

  return (
    <Overlay
      contentClassName={styles.overlay}
      isOpen={favouritesPopupVisible}
      onBackdropClick={handleClose}
      type="overlay/popup"
      isTransparent
    >
      <div className={styles.container}>
        <Button
          variant="text"
          className={styles.closeButton}
          onClick={handleClose}
        >
          <Cancel></Cancel>
        </Button>
        <div className={styles.content}>
          <FavoriteOutlined className={styles.star}></FavoriteOutlined>
          <div className={styles.title}>{'Legg til i favoritter'}</div>
          <div className={styles.subtitle}>
            {'Du må logge inn for å legge'}
            <br />
            {'til dine favoritter.'}
          </div>
          <div className={styles.buttons}>
            <Button
              size="medium"
              variant="contained"
              isActiveBrandColor
              rounded
              onClick={handleLoginClick}
              className={styles.button}
            >
              <Unlock></Unlock>
              {t('Log in')}
            </Button>
          </div>
        </div>
      </div>
    </Overlay>
  );
};

export { FavouritesPopup };
